import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LeadDetailPage from './pages/LeadDetailPage';
import ScraperPage from './pages/ScraperPage';
import GeoSearchPage from './pages/GeoSearchPage';
import CompanyLookupPage from './pages/CompanyLookupPage';
import BatchSearchPage from './pages/BatchSearchPage';
import PipelinePage from './pages/PipelinePage';
import EmailLookupPage from './pages/EmailLookupPage';
import EmailDirectoryPage from './pages/EmailDirectoryPage';
import RevenueSearchPage from './pages/RevenueSearchPage';
import SettingsPage from './pages/SettingsPage';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { token, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }
  
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route 
        path="/login" 
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } 
      />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/lead/:id" 
        element={
          <ProtectedRoute>
            <LeadDetailPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/scraper" 
        element={
          <ProtectedRoute>
            <ScraperPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/geo-search" 
        element={
          <ProtectedRoute>
            <GeoSearchPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/company-lookup" 
        element={
          <ProtectedRoute>
            <CompanyLookupPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/batch-search" 
        element={
          <ProtectedRoute>
            <BatchSearchPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/pipeline" 
        element={
          <ProtectedRoute>
            <PipelinePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/email-lookup" 
        element={
          <ProtectedRoute>
            <EmailLookupPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/email-directory" 
        element={
          <ProtectedRoute>
            <EmailDirectoryPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/revenue-search" 
        element={
          <ProtectedRoute>
            <RevenueSearchPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
